import { useState, useContext } from 'react';
import { AppContext } from 'commons-ui';
import _isNil from 'lodash/isNil';
import { ContentPropsT } from '../constants';

const useFilter = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { name } = submittedData;
			if (_isNil(name) || name === '') {
				showAlert('Name is a required field', { type: 'error' });
				return;
			}
			handleFilterSubmit({ name });
		} catch (error) {
			showAlert('Error in fetching legal details data.', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useFilter;
